// These button styles should be used across generic buttons for consistent default styling.
export function getBaseButtonStyle(theme) {
    return {
        root: Object.assign({ borderRadius: "4px", fontWeight: "400" }, theme.customSemanticElevations.control),
        rootPressed: Object.assign({}, theme.customSemanticElevations.controlPressed),
    };
}
// These button styles are base styles specific to the Button component itself, which is meant for
// typical buttons with text content.
export function getBaseDefaultButtonStyle(theme, primary) {
    return {
        flexContainer: {
            // // 180px is around the 26 character recommended cutoff for wrapping buttons with longer text.
            maxWidth: "180px",
            // Specify 30px minHeight here instead of 32px minHeight on root to accomodate rare case of Button text wrapping to multiple lines.
            minHeight: "30px",
        },
        label: {
            fontWeight: "400",
            lineHeight: "inherit",
            margin: "5px 0",
        },
        root: Object.assign({ height: "auto", 
            // 120px is the minWidth specified for buttons in the Windows Visual Library.
            minWidth: "120px" }, (primary && theme.customSemanticElevations.controlOnAccent)),
        rootHovered: Object.assign({}, (primary && theme.customSemanticElevations.controlHoverOnAccent)),
        rootPressed: Object.assign({}, (primary && theme.customSemanticElevations.controlPressedOnAccent)),
    };
}
// Provide this style for the many buttons in Widgets with minWidth of 150px.
export function getWideDefaultButtonStyle() {
    return {
        root: {
            minWidth: "150px",
        },
    };
}
